import type { InputHTMLAttributes, TextareaHTMLAttributes } from 'react'

// error accepts a string (useForm) or string[] (Rails errors via <Form>).
type Base = { label: string; hint?: string; error?: string | string[] }
type InputField = Base & { multiline?: false } & InputHTMLAttributes<HTMLInputElement>
type TextareaField = Base & { multiline: true } & TextareaHTMLAttributes<HTMLTextAreaElement>

// Shared Kraft form control: label + input/textarea + error. Works with
// Inertia's uncontrolled <Form> (name-based) and with useForm (value/onChange
// passed through). The @tailwindcss/forms base styles are overridden here.
const CONTROL =
  'mt-1.5 block w-full rounded-xl border-[1.5px] border-line bg-card px-3.5 py-2.5 text-ink placeholder:text-ink-faint focus:border-ink focus:ring-0'

export function Field({ label, hint, error, multiline, id, ...rest }: InputField | TextareaField) {
  const controlId = id ?? rest.name
  return (
    <div>
      <label htmlFor={controlId} className="block text-sm font-semibold text-ink">
        {label}
      </label>
      {hint && <p className="mt-1 text-sm text-ink-soft">{hint}</p>}
      {multiline ? (
        <textarea id={controlId} className={CONTROL} {...(rest as TextareaHTMLAttributes<HTMLTextAreaElement>)} />
      ) : (
        <input id={controlId} className={CONTROL} {...(rest as InputHTMLAttributes<HTMLInputElement>)} />
      )}
      {error && <p className="mt-1 text-sm text-flame-deep">{Array.isArray(error) ? error[0] : error}</p>}
    </div>
  )
}
